/**
 * Sidebar "view as client" gating — centralized so the rule lives in one place.
 *
 * A trainer using the app as a client ("client view") is allowed only when the
 * server says the user may self-track: `user.canSelfTrack`, derived on
 * /api/auth from the AppConfig `trainerSelfTracking` mode + the user's role.
 *
 * With the flag at its default ('admins'), canSelfTrack is true only for
 * platform admins — so swapping the old hardcoded `isPlatformAdmin` checks for
 * these helpers is behavior-preserving. Flipping the flag to 'trainers' then
 * opens client view to all coaches with NO further code change.
 */

/** Whether this user is allowed to use the app as a client (view-as-client). */
export function canUseClientView(user) {
  return !!(user && user.canSelfTrack);
}

/**
 * Resolve the effective view mode. Returns 'client' only when the user may
 * self-track AND has toggled into client view; otherwise 'trainer'. This also
 * neutralizes a stale `viewMode === 'client'` left in localStorage from a prior
 * session (e.g. after the flag was turned off).
 */
export function resolveViewMode(user, storedViewMode) {
  if (!canUseClientView(user)) return 'trainer';
  return storedViewMode === 'client' ? 'client' : 'trainer';
}
